export const SET_ONLINE = 'SET_ONLINE'
export const RECEIVE_ONLINE = 'RECEIVE_ONLINE'
export const RECEIVE_OFFLINE = 'RECEIVE_OFFLINE'

export const SET_ADMIN_ONLINE = 'SET_ADMIN_ONLINE'
export const RECEIVE_ADMIN_ONLINE = 'RECEIVE_ADMIN_ONLINE'
export const RECEIVE_ADMIN_OFFLINE = 'RECEIVE_ADMIN_OFFLINE'
